import jwt from 'jwt-simple';
import get from 'lodash/get';
import { AuthMethod } from 'config/constants';
import { getSsoUserToken } from './sso/selectors';
import { getSbaUserError, getSbaUserIsAuthenticating, getSbaUserToken } from './sba/selectors';

export const getAuthentication = (state) => get(state, 'authentication');
export const getAuthMethod = (state) => get(state, 'authentication.authMethod', AuthMethod.SBA);

export const getDecodedToken = (state) => {
  const token = getSbaUserToken(state);
  return token ? jwt.decode(token, null, true) : null;
};

export const getAuthIsAuthenticating = (state) => getSbaUserIsAuthenticating(state);
export const getAuthError = (state) => getSbaUserError(state);

export const getAuthToken = (state) => {
  switch (getAuthMethod(state)) {
    case AuthMethod.SBA:
      return getSbaUserToken(state) || undefined;
    case AuthMethod.WIDGET:
      return getSsoUserToken(state) || undefined;
    default:
      return undefined;
  }
};

export const getAuthorizationHeader = (state) => {
  const method = getAuthMethod(state);
  const token = getAuthToken(state);
  if (!token) return undefined;

  return method === AuthMethod.WIDGET ? `SSO ${token}` : `Bearer ${token}`;
};

export const getIsSSOLoginScreenVisible = (state) => get(state, 'authentication.isSSOLoginScreenVisible');
export const getHasFetchedBookingAuthMethod = (state) => get(state, 'authentication.hasFetchedBookingAuthMethod');
export const getIsSSOAuth = (state) => getAuthMethod(state) === AuthMethod.WIDGET;

export const getIsAuthenticatedWithGatekeeper = (state) => !!getSbaUserToken(state);
export const isAuthenticatedWithSSO = (state) => !!getSsoUserToken(state);
export const isAuthenticatedUser = (state) => getIsAuthenticatedWithGatekeeper(state) || isAuthenticatedWithSSO(state);
